// Control IDs shared by the ported product pages (sai's screens/product IDs).
// `key` is his screen key (see SCREEN_IDS in trapezium.js); the result is ours.
import { toTrapezium } from './trapezium';

export const IDS = {
  step: (key, step) => toTrapezium(`${key}.show-step-${step}`), // step = the step's key, never its position
  more: (key) => toTrapezium(`${key}.next`), // next step, or the next product on the last step
};
